export enum FormTypes {
    INSTANT_QUOTE = 'instant quote',
    AMENDMENTS = 'amendments',
    LOGIN = 'login',
}
